import styled from 'styled-components';
import { cvBreakpoint768 } from '@carvana/theme';
import { DocumentUpload } from '~/library/icons/src';

export const DashedWrapper = styled.div`
  align-items: center;
  background-color: ${props => props.dragging ? '#F4F8FA' : ''};
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${cvBreakpoint768}px) {
    border: dashed #AAB1C7 3px;
    border-radius: 16px;
  }
`;

export const DropContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  text-align: center;
  color: grey;
  font-size: 3;
`;

export const DocUploadIcon = styled(DocumentUpload)`
  width: 104px;
  height: 104px;
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const UploadWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`;

export const UploadText = styled.div`
  font-size: 20px;
  margin-top: 25px;
  margin-bottom: 14px;
  text-align: center;
  font-weight: 450;
`;
